export const TOKEN_KEY = 'TOKEN_KEY';
export const FILTERED_ITEMS = 'FILTERED_ITEMS';

export default {TOKEN_KEY, FILTERED_ITEMS};
